import React from "react";

import {FIELD_TYPE, tabKeys, TT_PHIEU_VTYT} from "types/enums";
import {DataFormField} from "types/models/input-field-type";

import {ColumnProps} from "../../../../../types/models";

const {INPUT, DATE, COMBO_BOX, AUTO_COMPLETE, SELECT, NUMBER} = FIELD_TYPE;

const listMonths = [];
for (let month = 1; month <= 12; month++) {
  listMonths.push({
    value: month,
    label: `Tháng ${month}`,
  });
}

//--------------------------------------------------------
const listYears = [];
const currentYear = new Date().getFullYear();
const startYear = 2020;
const endYear = currentYear + 100;
for (let year = startYear; year <= endYear; year++) {
  listYears.push({
    value: year,
    label: year.toString(),
  });
}

const allColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    disabledCheck: true,
    fixed: "left",
    width: 40,
    align: "center",
    isResizable: true,
  },
  {
    title: "Họ tên",
    key: "hoTen",
    show: true,
    dataIndex: "hoTen",
    width: 150,
    align: "left",
    fixed: "left",
    isResizable: true,
  },
  {
    title: "Đối tượng",
    key: "maLoaiHopDong",
    show: true,
    isResizable: true,
    dataIndex: "maLoaiHopDong",
    width: 90,
    align: "left",
    fixed: "left",
  },
  {
    title: "Mã NV",
    key: "maNhanVien",
    show: true,
    isResizable: true,
    dataIndex: "maNhanVien",
    width: 60,
    align: "left",
    fixed: "left",
  },
  {
    title: "Năm",
    key: "",
    show: true,
    dataIndex: "nam",
    align: "center",
    children :[
      {
        title: "Nghỉ phép sử dụng tháng",
        key: "nghiPhepSuDungThangTruoc",
        show: true,
        dataIndex: "nghiPhepSuDungThangTruoc",
        width: 80,
        align: "right",
        isResizable: true,
      },
            {
        title: "Nghỉ bù sử dụng tháng",
        key: "nghiBuSuDungThangTruoc",
        show: true,
        dataIndex: "nghiBuSuDungThangTruoc",
        width: 80,
        isResizable: true,
        align: "right"
      },
      {
        title: "Số ngày làm thêm phát sinh tháng",
        key: "soNgayLamThemPhatSinhThang",
        show: true,
        isResizable: true,
        dataIndex: "soNgayLamThemPhatSinhThang",
        width: 80,
        align: "right"
      },
      {
        title: "Số ngày làm thêm được tính lương tháng",
        key: "soNgayLamThemDuocTinhLuongThang",
        show: true,
        isResizable: true,
        dataIndex: "soNgayLamThemDuocTinhLuongThang",
        width: 80,
        align: "right",

      },
      {
        title: "Ngày nghỉ phép tháng theo tiêu chuẩn được hưởng",
        key: "ngayNghiPhepThang",
        show: true,
        isResizable: true,
        dataIndex: "ngayNghiPhepThang",
        width: 80,
        align: "right",

      },
      {
        title: "Tổng ngày nghỉ phép được hưởng",
        key: "tongNgayNghiPhepDuocHuong",
        show: true,
        isResizable: true,
        dataIndex: "tongNgayNghiPhepDuocHuong",
        width: 80,
        align: "right",

      },
      {
        title: "Số ngày nghỉ phép năm",
        key: "soNgayNghiPhepNam",
        show: true,
        isResizable: true,
        dataIndex: "soNgayNghiPhepNam",
        width: 80,
        align: "right",

      },
      {
        title: "Tổng số ngày nghỉ bù được hưởng",
        key: "tongSoNgayNghiBuDuocHuong",
        show: true,
        dataIndex: "tongSoNgayNghiBuDuocHuong",
        width: 80,
        isResizable: true,
        align: "right",

      },
      {
        title: "Số ngày nghỉ bù năm",
        key: "soNgayNghiBuNam",
        show: true,
        isResizable: true,
        dataIndex: "soNgayNghiBuNam",
        width: 80,
        align: "right",
      },

    ]
  },
];

const itemsInputField: DataFormField[] = [
  {
    type: COMBO_BOX,
    label: "Phòng",
    name: "phong",
    disable: false,
  },
  {
    type: INPUT,
    label: "Mã NV",
    name: "maNhanVien",
    disable: false,
  },
  {
    type: INPUT,
    label: "Họ tên",
    name: "hoTen",
    disable: false,
  },
  {
    type: COMBO_BOX,
    name: "thang",
    label: "Tháng",
    disable: false,
    options: listMonths,
    rules: [{ required: true, message: "Vui lòng chọn tháng" }],
  },
  {
    type: COMBO_BOX,
    name: "nam",
    label: "Năm",
    disable: false,
    rules: [{ required: true, message: "Vui lòng chọn năm" }],
    options: listYears,

  },
];

export {allColumns, itemsInputField};
